export default __webpack_public_path__ + "h9.png";